export const onlinePaymentExcludedCountries = ["RS"];

export function isAnyLocationExcludedFromOnlinePayments(
  locations: { country: string }[] | undefined | null,
): boolean {
  return (
    locations?.some((location) =>
      onlinePaymentExcludedCountries.includes(location.country),
    ) ?? false
  );
}

export function resolveDefaultCreatePayment({
  locations,
  doesAnyServiceRequirePayment,
  isPaymentDefaultCheckedInDashboard,
}: {
  locations: { country: string }[] | undefined | null;
  doesAnyServiceRequirePayment: boolean;
  isPaymentDefaultCheckedInDashboard: boolean;
}): boolean {
  return (
    !isAnyLocationExcludedFromOnlinePayments(locations) &&
    doesAnyServiceRequirePayment &&
    isPaymentDefaultCheckedInDashboard
  );
}

export function syncCreatePaymentWithLocationExclusion(
  createPayment: boolean,
  locations: { country: string }[] | undefined | null,
): boolean {
  if (isAnyLocationExcludedFromOnlinePayments(locations)) {
    return false;
  }
  return createPayment;
}

export function buildPaymentDetailsForSubmit<T extends object>(
  createPayment: boolean,
  details: T,
): T | undefined {
  return createPayment ? details : undefined;
}
